import $ from 'zepto';
import { onDocumentReady, expose } from '../../main';
import Field from './Field';
import SelectField from './SelectField';
import { isVisible } from '../../utils';

import {
  listFieldFooterMessageSelector,
  listMessageSelector,
} from '../../utils/constants/classes';

const $body = $(document.body);
const ANIMATE_DURATION = 600;

export function addErrorStatus(element, fieldClass) {
  const parentSelector = `.${fieldClass}`;
  const errorParentClass = `${fieldClass}--error`;

  $(element)
    .closest(parentSelector)
    .addClass(errorParentClass);
}

export function addManyErrorStatus(elements, fieldClass) {
  elements.forEach((element) => {
    addErrorStatus(element, fieldClass);
  });
}

export function removeErrorStatus(element, fieldClass) {
  const errorParentClass = `${fieldClass}--error`;
  const parentSelector = `.${fieldClass}`;

  $(element)
    .closest(parentSelector)
    .removeClass(errorParentClass);
}

export function removeManyErrorStatus(elements, fieldClass) {
  elements.forEach((element) => {
    removeErrorStatus(element, fieldClass);
  });
}

export const getFieldClasses = (controlClass, fieldClass) => {
  const labellessFieldClass = `${fieldClass}--label-less`;
  const smallFieldClass = `${fieldClass}--small`;
  const iconClass = `${fieldClass}__icon`;
  const iconSelector = `.${iconClass}`;
  const fieldSelector = `.${fieldClass}`;
  const errorFieldClass = `${fieldClass}--error`;
  const controlSelector = `.${controlClass}`;
  const selectControlSelector = `select.${controlClass}`;
  const closeFieldClass = `${fieldClass}--close`;
  const focusFieldClass = `${fieldClass}--focus`;
  const fieldGroup2Class = `${fieldClass}-group-2`;
  const passwordFieldClass = `${fieldClass}--password`;
  const passwordIconClass = `${passwordFieldClass}-icon`;
  const fieldNoEditableClass = `${fieldClass}--no-editable`;

  return {
    labellessFieldClass,
    smallFieldClass,
    iconClass,
    iconSelector,
    errorFieldClass,
    fieldClass,
    controlClass,
    controlSelector,
    fieldSelector,
    selectControlSelector,
    closeFieldClass,
    focusFieldClass,
    fieldGroup2Class,
    passwordFieldClass,
    passwordIconClass,
    fieldNoEditableClass,
  };
};

export const getSelectFieldClasses = (baseClasses) => {
  const customControlClass = `${baseClasses.controlClass}--custom`;
  const customPlaceholderControlClass = `${baseClasses.controlClass}--placeholder`;
  const controlValueClass = `${baseClasses.controlClass}__value`;
  const listClass = `${baseClasses.fieldClass}__list`;
  const listSelector = `.${listClass}`;
  const itemClass = `${listClass}__item`;
  const itemSelector = `.${itemClass}`;
  const iconItemClass = `${listClass}__icon`;
  const selectedItemClass = `${itemClass}--selected`;
  const selectedItemSelector = `.${selectedItemClass}`;
  const focusItemClass = `${itemClass}--focus`;
  const focusItemSelector = `.${focusItemClass}`;
  const listFieldClass = `${baseClasses.fieldClass}--list`;
  const openListFieldClass = `${baseClasses.fieldClass}--list-open`;
  const fullWidthListClass = `${baseClasses.fieldGroup2Class}--wide-list`;
  const openWideListClass = `${fullWidthListClass}-open`;
  const focusWideListClass = `${fullWidthListClass}-focus`;

  return {
    customControlClass,
    customPlaceholderControlClass,
    controlValueClass,
    listClass,
    listSelector,
    itemClass,
    itemSelector,
    iconItemClass,
    selectedItemClass,
    selectedItemSelector,
    focusItemClass,
    focusItemSelector,
    openListFieldClass,
    listFieldClass,
    fullWidthListClass,
    openWideListClass,
    focusWideListClass,
  };
};

export function initFields(controlClass, fieldClass, $context) {
  const baseClasses = getFieldClasses(controlClass, fieldClass);
  const selectClasses = getSelectFieldClasses(baseClasses);

  $context.find(baseClasses.fieldSelector)
    .not('.xvx-field--no-editable')
    .each((index, element) => {
      const $field = $(element);
      const $select = $field.find('select');
      if ($select.length === 1) {
        new SelectField({ ...baseClasses, ...selectClasses })
          .initSelectField($field, $select);
      } else {
        new Field(baseClasses).initField($field);
      }
    });
}

onDocumentReady('Fields', () => {
  initFields('xvx-field__control', 'xvx-field', $body);
  initFields('xvx-custom-field__control', 'xvx-custom-field', $body);
});

/**
 * toggle visibility of list message
 *
 * @param {Zepto} field
 */
export function toggleMessageList($field) {
  const listMessage = $field.next(listFieldFooterMessageSelector).find(listMessageSelector);
  if (isVisible(listMessage)) {
    $(listMessageSelector).slideUp(ANIMATE_DURATION);
  } else {
    $(listMessageSelector).slideDown(ANIMATE_DURATION);
  }
}

expose({
  initFields,
  addErrorStatus,
  removeErrorStatus,
  addManyErrorStatus,
  removeManyErrorStatus,
  toggleMessageList,
});

export default {
  initFields,
  addErrorStatus,
  removeErrorStatus,
  toggleMessageList,
  addManyErrorStatus,
  removeManyErrorStatus,
};
